import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import echarts from 'echarts'
import * as echarts from 'echarts'
import VueDND from 'awe-dnd'
Vue.prototype.$echarts = echarts

import Print from 'vue-print-nb'
Vue.use(Print); //注册
Vue.config.productionTip = false
// 引用组件
Vue.use(ElementUI)
Vue.use(VueDND)


import Avue from '@smallwei/avue';
import '@smallwei/avue/lib/index.css';
Vue.use(Avue);
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
import { loadScript } from '/src/avueBaseData/utils/utils'
window.$loadScript = loadScript;

//解决启动时报错依赖问题; add by zhaocl(2024-12-09)
import RelationGraph from 'relation-graph';
const { element, isFullscreen, off, on, toggle } = RelationGraph;


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})
